import * as React from 'react';
import { Button, Grid, List, Paper, Typography } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { styles } from './styles';
import noAvailablePicture from '../../assets/utils/NopictureAvailable.png';

const { Fragment } = React;

export const RestaurantEditImages: React.FC = () => {
  const classes = styles();
  const { t } = useTranslation();

  return (
    <Fragment>
      <Typography variant="subtitle1">
        {t('restaurant.info.edit.restaurantPicture')}
      </Typography>

      <Paper variant="outlined" className={classes.listBox}>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          className={classes.listBoxHead}
        >
          <Grid item>
            <Typography>{t('restaurant.info.edit.pictures')}</Typography>
          </Grid>
          <Grid item>
            <Button endIcon={<Add />} className={classes.listBoxHeadButton}>
              {t('restaurant.info.edit.addMore')}
            </Button>
          </Grid>
        </Grid>
        <div className={classes.pictureContainer}>
          <figure>
            <img
              src={noAvailablePicture}
              alt={t('restaurant.info.edit.noPictureSelected')}
              className={classes.picture}
            />
            <figcaption>
              {t('restaurant.info.edit.noPictureSelected')}
            </figcaption>
          </figure>
        </div>
        <List></List>
      </Paper>
    </Fragment>
  );
};
